import axios from "axios";
import React, { useState, useEffect } from "react";
import { getClientToken } from "../components/cookie/getClientToken";
import { Domain } from "../Domain/Domain";
import useGetCartDetailsHook from "./useGetCartDetailsHook";
import useGetDefaultAddress from "../Hooks/useGetDefaultAddress";
import { useNavigate } from "react-router-dom";
import { getCookieUser } from "../components/cookie/getCookieUser";
import { useDispatch } from "react-redux";
import { toggleAlertAction } from "../store/slices/alertSlice";
const useCheckoutHook = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState<boolean>(false);
  const [message, setMessage] = useState({ error: "", success: "" });
  const { defaultAddress } = useGetDefaultAddress();
  const cart = useGetCartDetailsHook();
  const navigate = useNavigate();

  const onSuccess = (reference: any) => {
    // console.log("====>", reference);
    console.log(reference);
    setLoader(true);
    let cartList = cart.cart;

    console.log("=====>", getCookieUser().email);

    let orderData = {
      payment_ref: reference.reference,
      delivery_address: defaultAddress,
      products: cartList.map((cur: any) => {
        delete cur.color;
        delete cur.images;
        delete cur.date;
        delete cur.priceing;
        return cur;
      }),
    };
    console.log(orderData);

    axios
      .post(Domain() + "/api/v1/order/new", JSON.stringify(orderData), {
        headers: {
          Authorization: getClientToken(),
          "Content-Type": "application/json",
        },
      })

      .then((response: any) => {
        setLoader(false);
        // console.log(response.data);
        if (response.data.status === 200) {
          localStorage.removeItem('cart')
          navigate("/my-order-detail?order_id=" + response.data.data.id);
        }
      })
      .catch((error) => {
        console.log(error);
        console.log(error.response.data.data);
        setLoader(false);
        // console.log(error);
        // alert(error?.response?.data?.data);
        dispatch(
          toggleAlertAction({
            isAlerting: true,
            message: error?.response?.data?.data,
            status: "error",
          })
        );
      });
  };
  return { loader, onSuccess };
};

export default useCheckoutHook;
